/**
 * "Vis flere" på kollektionssiderne (Amplify 7/9-2026).
 *
 * Henter næste side med Section Rendering API og hægter varerne på det gitter der står.
 * De første par sider hentes af sig selv, når kunden ruller ned. Derefter kræver det et klik,
 * så footeren stadig kan nås i en kollektion med tusindvis af varer.
 *
 * Temaet gentegner hele .collection__dynamic-part ved filter- og sorteringsskift, så alt her
 * er bundet med delegering eller genfindes efter behov. Ingen referencer holdes på tværs.
 */
(function () {
  'use strict';

  var GITTER = '.product-list--collection';
  var MAKS_AUTO = 3; // sider der hentes uden klik, derefter tager kunden over

  var henter = false;
  var automatiskeHentninger = 0;
  var kigger = null;

  function kasse() {
    return document.querySelector('[data-b24-mere]');
  }

  function skjulPaginering() {
    var p = document.querySelector('.collection__dynamic-part .pagination');
    if (p) p.classList.add('b24-paginering-skjult');
  }

  function adresse(boks, side) {
    var u = new URL(window.location.href);
    u.searchParams.set('page', side);
    return u.pathname + u.search + '&section_id=' + boks.getAttribute('data-sektion');
  }

  // Naar udsolgte varer skjules, passer paginate.items ikke, for den taeller ogsaa dem vi
  // springer over. Saa taeller vi kortene i gitteret og lader fremdriften foelge siderne.
  function visStatus(boks) {
    // Kun DIREKTE boern der er produktkort. Alt andet i gitteret (noter, indskudte raekker)
    // skal ikke taelle med som varer.
    var gitter = document.querySelector(GITTER);
    var vist = 0;
    if (gitter) {
      for (var b = 0; b < gitter.children.length; b++) {
        if (gitter.children[b].classList.contains('product-item')) vist++;
      }
    }
    var skjuler = boks.getAttribute('data-skjuler') === '1';
    var iAlt = parseInt(boks.getAttribute('data-i-alt'), 10) || 0;
    var side = parseInt(boks.getAttribute('data-side'), 10) || 1;
    var sider = parseInt(boks.getAttribute('data-sider'), 10) || 1;

    var s = boks.querySelector('[data-b24-mere-status]');
    if (s) {
      s.innerHTML = skjuler
        ? 'Viser <strong>' + vist + '</strong> varer p\u00e5 lager'
        : 'Viser <strong>' + vist + '</strong> af ' + iAlt + ' varer';
    }
    var f = boks.querySelector('.b24-mere__fyld');
    if (f) {
      var pct = skjuler ? (side / sider) * 100 : (iAlt > 0 ? (vist / iAlt) * 100 : 0);
      f.style.width = Math.min(100, Math.round(pct)) + '%';
    }
  }

  function stopKig() {
    if (kigger) { kigger.disconnect(); kigger = null; }
  }

  function hent(automatisk) {
    var boks = kasse();
    if (!boks || henter) return;

    var side = parseInt(boks.getAttribute('data-naeste'), 10);
    if (!side) { stopKig(); return; }

    var gitter = document.querySelector(GITTER);
    if (!gitter) return;

    henter = true;
    if (automatisk) automatiskeHentninger++;
    boks.classList.add('er-i-gang');

    fetch(adresse(boks, side), { credentials: 'same-origin' })
      .then(function (svar) {
        if (!svar.ok) throw new Error('HTTP ' + svar.status);
        return svar.text();
      })
      .then(function (html) {
        var midlertidig = document.createElement('div');
        midlertidig.innerHTML = html;

        var nye = midlertidig.querySelector(GITTER);
        if (!nye) throw new Error('produktlisten mangler i svaret');

        // Udsolgte varer ligger sidst via CSS order, ikke via DOM-raekkefoelge. Nye varer paa
        // lager bliver derfor tegnet OVER dem, og alt under flytter sig. Vi holder fast i den
        // foerste vare der er synlig, og retter rullepositionen bagefter, saa intet hopper.
        var anker = null, ankerFoer = 0;
        var kort = gitter.children;
        for (var i = 0; i < kort.length; i++) {
          var kasse2 = kort[i].getBoundingClientRect();
          if (kasse2.bottom > 0) { anker = kort[i]; ankerFoer = kasse2.top; break; }
        }

        var stump = document.createDocumentFragment();
        while (nye.firstChild) stump.appendChild(nye.firstChild);
        gitter.appendChild(stump);

        if (anker) {
          var flyt = anker.getBoundingClientRect().top - ankerFoer;
          if (Math.abs(flyt) > 1) window.scrollBy(0, flyt);
        }

        var nyBoks = midlertidig.querySelector('[data-b24-mere]');
        var naeste = nyBoks ? (nyBoks.getAttribute('data-naeste') || '') : '';

        boks.setAttribute('data-naeste', naeste);
        boks.setAttribute('data-side', String(side));
        visStatus(boks);

        if (!naeste) {
          var knap = boks.querySelector('[data-b24-mere-knap]');
          if (knap) knap.parentNode.removeChild(knap);
          stopKig();
        } else if (automatiskeHentninger >= MAKS_AUTO) {
          stopKig();
        }
      })
      .catch(function (fejl) {
        var tekst = boks.querySelector('.b24-mere__tekst');
        if (tekst) tekst.textContent = 'Kunne ikke hente flere. Prøv igen';
        stopKig();
        if (window.console && console.warn) console.warn('[b24-vis-flere]', fejl);
      })
      .then(function () {
        henter = false;
        boks.classList.remove('er-i-gang');
        // IntersectionObserver fyrer kun naar noget KRYDSER graensen. Markoeren bliver liggende
        // i syne efter en hentning, saa der kommer ingen ny besked. Vi observerer forfra, hvilket
        // udloeser tilbagekaldet med det samme hvis markoeren stadig er synlig.
        if (boks.getAttribute('data-naeste') && automatiskeHentninger < MAKS_AUTO) armer();
      });
  }

  function armer() {
    var boks = kasse();
    if (!boks) { stopKig(); return; }

    skjulPaginering();
    visStatus(boks);
    stopKig();

    if (!boks.getAttribute('data-naeste')) return;
    if (automatiskeHentninger >= MAKS_AUTO) return;
    if (!('IntersectionObserver' in window)) return;

    kigger = new IntersectionObserver(function (poster) {
      poster.forEach(function (post) {
        if (post.isIntersecting) hent(true);
      });
    }, { rootMargin: '600px 0px' });

    kigger.observe(boks);
  }

  // Klik virker altid, også efter at temaet har gentegnet blokken
  document.addEventListener('click', function (e) {
    var knap = e.target.closest && e.target.closest('[data-b24-mere-knap]');
    if (!knap) return;
    e.preventDefault();
    hent(false);
  });

  // Temaet skifter hele .collection__dynamic-part ud ved filter og sortering.
  // Så nulstiller vi tælleren og armer forfra på den nye boks.
  var ventende = null;
  new MutationObserver(function (aendringer) {
    var relevant = aendringer.some(function (a) {
      return [].some.call(a.addedNodes, function (n) {
        return n.nodeType === 1 && n.querySelector && (n.matches('[data-b24-mere]') || n.querySelector('[data-b24-mere]'));
      });
    });
    if (!relevant) return;
    clearTimeout(ventende);
    ventende = setTimeout(function () { automatiskeHentninger = 0; armer(); }, 60);
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armer);
  } else {
    armer();
  }
})();
